export enum contactAttemptTypes {
  alert = 'Alert',
}
